import sort from './sort.vue'
import upload from './upload.vue'
import chainedSelects from './chainedSelects.vue'
import textMultiple from './textMultiple.vue'
import evaluate from './evaluate.vue'
import nps from './nps.vue'

export {
  sort,
  upload,
  chainedSelects,
  textMultiple,
  evaluate,
  nps
}



// WEBPACK FOOTER //
// ./src/components/ques-widget.js